import { render, staticRenderFns } from "./ActivityView.vue?vue&type=template&id=687f1084&scoped=true&"
import script from "./ActivityView.vue?vue&type=script&lang=js&"
export * from "./ActivityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687f1084",
  null
  
)

export default component.exports